/*
 *  This has been generated using the Synergy STDev tool.
 *  Any modifications will be lost after the next build
 */
import * as pxp from './PXPApp'
import { componentApi, loadTranslations } from 'common'


export class LaunchPad {
  async GetPXPModules(userType : pxp.UserType) : Promise<Array<pxp.ModuleConfigInfo>> {
    return await componentApi.call('pxp', 'launch-pad', 'LaunchPad', 'GetPXPModules', {
      userType,
    });
  }
  async GetPXPModuleDefs() : Promise<Array<pxp.PXPModuleDef>> {
    return await componentApi.call('pxp', 'launch-pad', 'LaunchPad', 'GetPXPModuleDefs', {
    });
  }
  async GetConfiguration(launchPadGU : string) : Promise<any> {
    return await componentApi.call('pxp', 'launch-pad', 'LaunchPad', 'GetConfiguration', {
      launchPadGU,
    });
  }
  async GetOLRModuleDefs() : Promise<Array<pxp.PXPModuleDef>> {
    return await componentApi.call('pxp', 'launch-pad', 'LaunchPad', 'GetOLRModuleDefs', {
    });
  }
  async GetANAModuleDefs(userType : pxp.UserType) : Promise<Array<pxp.PXPModuleDef>> {
    return await componentApi.call('pxp', 'launch-pad', 'LaunchPad', 'GetANAModuleDefs', {
      userType,
    });
  }
  async GetSecurityOptions() : Promise<any> {
    return await componentApi.call('pxp', 'launch-pad', 'LaunchPad', 'GetSecurityOptions', {
    });
  }
  async GetLaunchUrl(url : string, agu : string) : Promise<string> {
    return await componentApi.call('pxp', 'launch-pad', 'LaunchPad', 'GetLaunchUrl', {
      url,
      agu,
    });
  }
  async GetLaunchPadDefinition(launchPadGU : string) : Promise<pxp.LaunchPadDefinition> {
    return await componentApi.call('pxp', 'launch-pad', 'LaunchPad', 'GetLaunchPadDefinition', {
      launchPadGU,
    });
  }
}

export class LaunchPadTransformer {
  async GetFontCodes(ttfFile : string) : Promise<Array<string>> {
    return await componentApi.call('pxp', 'launch-pad', 'LaunchPadTransformer', 'GetFontCodes', {
      ttfFile,
    });
  }
  async Transform(htmlStream : any) : Promise<any> {
    return await componentApi.call('pxp', 'launch-pad', 'LaunchPadTransformer', 'Transform', {
      htmlStream,
    });
  }
}
export default new LaunchPad()
